import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBCodeRateSetup } from "../../components/WSIBCodeRateSetup";

export const WSIBCodeRateSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Code Rate Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Code Rate Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBCodeRateSetup />}
    />
  );
};
